import React from "react";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";

import Badge from "@mui/material/Badge";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";

import CloudSyncOutlinedIcon from "@mui/icons-material/CloudSyncOutlined";

const WorkspaceApply = ({showIntro}) => {
  const { Workspace_id } = useParams();
  const workspace = useSelector((state) => state.workspace);
  const { ModelingStatus } = workspace?.workspace ?? {};

  const navigate = useNavigate();

  return (
    <Tooltip title="Apply to Data Warehouse" arrow>
      <Badge
        overlap="circular"
        badgeContent=" "
        variant="dot"
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        sx={{
          "& .MuiBadge-badge": {
            transform: "rotate(-60deg)",
            backgroundColor: [1, 4].includes(ModelingStatus) ? "#d32f2f" : "transparent",
          },
        }}
      >
        <IconButton onClick={() => navigate(`/my-workspaces/${Workspace_id}/config`)} size="small" sx={{ m: 0.5 }}>
          <CloudSyncOutlinedIcon sx={{ width: 28, height: 28 }} className="applytodw" color="secondary" />
        </IconButton>
      </Badge>
    </Tooltip>
  );
};

export default WorkspaceApply;
